import { Typography } from '@mui/material';
import { FINPSP_WITHDRAWAL_CHANNELS } from '../../../constants/finpsp';
import { useFinpspWithdrawalForm } from '../../../hooks/payment/finpsp/useFinpspWithdrawalForm';
import useLocalization from '../../../hooks/useLocalization';
import { FormTextField } from '../../molecules/form-elements';
import StyledForm from '../shared/StyledForm';
import FinpspPaymentTypeField from './FinpspPaymentTypeField';
import type { FinpspFormProps } from './finpspForms';
import { finpspFormStyles } from './finpspFormStyles';

const FinpspWithdrawForm = ({ paymentProvider }: FinpspFormProps) => {
  const { t } = useLocalization();
  const { form, withdrawalType, withdrawalTypes, isSubmitting, onSubmit } = useFinpspWithdrawalForm(paymentProvider);
  const { errors } = form.formState;

  if (withdrawalTypes.length === 0) {
    return (
      <Typography variant='body2' color='text.secondary'>
        {t('finpspWithdrawalsUnavailable')}
      </Typography>
    );
  }

  return (
    <StyledForm
      submitTitle={t('continue')}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      disablePadding
      sx={finpspFormStyles}
    >
      <FinpspPaymentTypeField
        name='type'
        control={form.control}
        types={withdrawalTypes}
        value={withdrawalType}
        channels={FINPSP_WITHDRAWAL_CHANNELS}
        disabled={isSubmitting}
      />

      <FormTextField
        name='amount'
        control={form.control}
        label={t('finpspAmount')}
        fullWidth
        error={!!errors.amount}
        helperText={errors.amount?.message}
        disabled={isSubmitting}
        required
        slotProps={{ htmlInput: { inputMode: 'decimal' } }}
      />

      <FormTextField
        name='customer_phone'
        control={form.control}
        label={t('phoneNumber')}
        type='tel'
        fullWidth
        error={!!errors.customer_phone}
        helperText={errors.customer_phone?.message}
        disabled={isSubmitting}
        required
        slotProps={{ htmlInput: { inputMode: 'tel' } }}
      />
    </StyledForm>
  );
};

export default FinpspWithdrawForm;
